

import React from 'react';
import './footer.css';
import { FaFacebook, FaLinkedin, FaInstagram } from 'react-icons/fa'; // Importing social media icons
import { useNavigate  } from 'react-router-dom';
function Footer() {

  const navigate = useNavigate();

  const handleJobClick = () => {
    // Navigate to Contact Us page
    navigate('/contact');

    // Scroll to Candidate Google Form section
    setTimeout(() => {
      const formElement = document.getElementById('candidate-form');
      if (formElement) {
        formElement.scrollIntoView({ behavior: 'smooth' });
      }
    }, 500);
  };


  const handleContactClick = () => {
    // Navigate to Contact Us page
    navigate('/contact');

    // Scroll to Contact Details section
    setTimeout(() => {
      const formElement = document.getElementById('contact-details-section');
      if (formElement) {
        formElement.scrollIntoView({ behavior: 'smooth' });
      }
    }, 500);
  };



  return (
    <> 
      <footer className="footer">
        <div className="footer-column left-align">
          <h3>Who we are?</h3>
          <p>
            We are a leading tech solutions provider, committed to delivering innovative services to our clients worldwide.
          </p>
          <a href="/about" className="footer-link readmore-link">Read More</a>
        </div>
        <div className="footer-column">
          <h3>For Employers</h3>
          <button className="footer-button" onClick={() => window.location.href = '/contact'}>Send Job Opening</button>
          <h3>For Candidates</h3>
          <button className="footer-button" onClick={handleJobClick}>Jobs</button>
        </div>
        <div className="footer-column">
          <h3>Services</h3>
          <p>Recruitment Services</p>
          <p>Executive Search</p>
          <p>Manpower Staffing</p>
          <p>Training & Development</p>
        </div>
        <div className="footer-column">
          <h3><a href="/about" className="footer-link">About ShriTech</a></h3>
          <p><a href="/about" className="footer-link">Our Vision and Mission</a></p>
          <p>Strengths of ShriTech</p>
          <p>Recruitment Process</p>
          <button className="footer-button" onClick={handleContactClick}>Get In Touch</button>
          <div className="social-icons">
            <a href="https://www.facebook.com/profile.php?id=61566070950989&mibextid=ZbWKwL" target="_blank" rel="noopener noreferrer">
              <FaFacebook />
            </a>
            <a href="https://www.linkedin.com/company/shritech.in/" target="_blank" rel="noopener noreferrer">
              <FaLinkedin />
            </a>
            <a href="https://www.instagram.com/shritech.hiringplatform?igsh=MTIwMTB0dmZ2bTVjZQ==" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a>
          </div>
        </div>
        <div className="footer-bottom">
          <p>Copyright &copy; 2024 Shritech Consultants Pvt. Ltd. All Rights Reserved. Developed & Maintained by Samiksha Umbarje.</p>
        </div>
      </footer> 
    </>
  );
}

export default Footer;































/*import React from 'react';
import './footer.css';
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram } from 'react-icons/fa'; // Importing social media icons

function footer() {
  return (
    <> <footer className="footer">


    <div className="footer-column left-align">
        <h3>Who we are ?</h3>
        <p>
          We are a leading tech solutions provider, committed to delivering innovative services to our clients worldwide.
        </p>
        <a href="/about" className="footer-link readmore-link" >Read More</a>
        
      </div>
      <div className="footer-column">
        

        <h3>For Employers</h3>
        <p><a href="/contact" className="footer-link">Send Job Opening</a></p>
        <h3>For Candidates</h3>
        <p><a href="/contact" className="footer-link">Jobs</a></p>

      </div>
      <div className="footer-column">
        <h3>Services</h3>
        <p>Recruitment Services</p>
        <p>Executive Search</p>
        <p>Manpower Staffing</p>
        <p>Training & Development</p>
      </div>
      <div className="footer-column">
        <h3><a href="/about" className="footer-link">About ShriTech</a></h3> 
        <p><a href="/about" className="footer-link">Our Vision and Mission</a></p>
        <p>Strengths of Shritech</p>
        <p>Benefits of partnering with us</p>
        <p>Recruitment process</p>
            <div className="social-icons">
               <a href="https://www.facebook.com/profile.php?id=61566070950989&mibextid=ZbWKwL" target="_blank" rel="noopener noreferrer">
                <FaFacebook />
              </a>
              
              <a href="https://www.linkedin.com/company/shritech.in/" target="_blank" rel="noopener noreferrer">
                <FaLinkedin />
              </a>
              <a href="https://www.instagram.com/shritech.hiringplatform?igsh=MTIwMTB0dmZ2bTVjZQ==" target="_blank" rel="noopener noreferrer">
                <FaInstagram />
              </a>

        </div>
      </div>
      <div className="footer-bottom">
        <p> Copyright &copy; 2024 Shritech Consultants Pvt. Ltd. All Rights Reserved. Developed & Maintained by Samiksha Umbarje.</p>
      </div>


    </footer> </>
    
  );
}

export default footer;


*/